import React from 'react';
import { useTranslation } from 'react-i18next';

import WebsiteSpeedHero from '../components/WebsiteSpeedHero/WebsiteSpeedHero';
import WebsiteSpeedFeatures from '../components/WebsiteSpeedFeatures/WebsiteSpeedFeatures';
import WebsiteSpeedProcess from '../components/WebsiteSpeedProcess/WebsiteSpeedProcess';
import WebsiteSpeedPortfolio from '../components/WebsiteSpeedPortfolio/WebsiteSpeedPortfolio';
import ModernWhyChooseUs from '../components/ModernWhyChooseUs/ModernWhyChooseUs';
import WebsiteSpeedCta from '../components/WebsiteSpeedCta/WebsiteSpeedCta';

const WebsiteSpeedPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <WebsiteSpeedHero />
      <WebsiteSpeedFeatures />
      <WebsiteSpeedProcess />
      <WebsiteSpeedPortfolio />
      <ModernWhyChooseUs />
      <WebsiteSpeedCta />
    </>
  );
};

export default WebsiteSpeedPage;
